import AnalyticsProvider, { useAnalytics } from './AnalyticsProvider';

export default AnalyticsProvider;
export { useAnalytics };
